export default __webpack_public_path__ + "static/media/world-cup-vs-bg-mobile.694534a5.jpg";